<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./button.scss";
</style>

<template>
  <button
    :class="`slk-g-btn slk-btn-s-${size} slk-btn-v-${variant} ${buttonStyle} ${iconLeft ? '_icon' : ''} ${
      iconRight ? 'icon_' : ''
    } ${fullWidth ? `full-width` : ``} ${iconOnly ? 'icon-only' : ''}`"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span class="_slk-btn-icon" v-if="iconLeft">
      <svg class="feather">
        <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
      </svg>
    </span>
    <span v-if="loading" class="__loader">
      <LoaderView :color="buttonStyle === `filled` ? `default` : `primary`" :class="size" />
    </span>
    <div class="slk-btn-content" v-else>
      <span class="slk-btn-icon" v-if="iconOnly">
        <svg class="feather">
          <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
        </svg>
      </span>
      <span class="text" v-else>{{ text }}</span>
    </div>
    <span class="slk-btn-icon_" v-if="iconRight">
      <svg class="feather">
        <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
      </svg>
    </span>
  </button>
</template>

<script>
// Components
import LoaderView from "../loader/loaderView.vue";

export default {
  name: "button-view",
  props: {
    size: { type: String, default: "medium" },
    variant: { type: String, defaut: "primary" },
    buttonStyle: { type: String, default: "filled" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    text: { type: String },
    fullWidth: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    iconLeft: { type: Boolean, default: false },
    iconRight: { type: Boolean, default: false },
    icon: { type: String },
  },
  components: {
    LoaderView,
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>
